'use client';

import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export interface UserDataState {
  id: string;
  name: string;
  email: string;
  photo: string;
}

export const initialUserDataState: UserDataState = {
  id: '',
  name: '',
  email: '',
  photo: '',
};

export const userDataSlice = createSlice({
  name: 'userData',
  initialState: initialUserDataState,
  reducers: {
    setUserData: (_state, action: PayloadAction<UserDataState>) => {
      return action.payload;
    },
  },
});

export const { setUserData } = userDataSlice.actions;
export default userDataSlice.reducer;
